import React from "react";
import RollingAdvanceComponent from "./RollingAdvanceComponent";
// import RollingAdvanceComponent from "../Dashboard/Graph";
import CreditCustomerPartnerComponent from "./CreditCustomerPartnerComponent";
import { store } from "../../Store/store";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import 'react-datepicker/dist/react-datepicker.css';

const TransactionComponent = () => {

    const userInfo = store.getState();
    const paymentType = userInfo?.Partner_Account_Details?.MHL_Payment_Type__c;

    if (paymentType === "Rolling Advance") {
        return <RollingAdvanceComponent />;
    } else if (paymentType === "Credit" || paymentType === "Cash") {
        return <CreditCustomerPartnerComponent />;
        // return <RollingAdvanceComponent />;
    } else {
        return (
            <div className="text-center p-5 text-muted">
                <h5>Unsupported Payment Type</h5>
                <p>Please contact admin.</p>
            </div>
        );
    }
};

export default TransactionComponent;


// import React, { useState, useRef, useEffect, useContext, useCallback } from "react";
// import "../../Complaint.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import CommonContainer from "../Container/CommonContainer";
// import ReactDatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';

// const TransactionComponent = () => {

//     const [monthYear, setMonthYear] = useState(new Date());


//     const data = [
//         {
//             transactionDate: "25-04-2025",
//             vid: "250176500003642",
//             totalAmount: 56,
//             raDeposit: 0,
//             depositDate: "",
//             balanceAmount: 4347,
//             locationName: "PUNE MAIN LAB",
//             organizationName: "Pune",
//         },
//         {
//             transactionDate: "25-04-2025",
//             vid: "250176500003641",
//             totalAmount: 56,
//             raDeposit: 0,
//             depositDate: "",
//             balanceAmount: 4403,
//             locationName: "PUNE MAIN LAB",
//             organizationName: "Pune",
//         },
//         {
//             transactionDate: "25-04-2025",
//             vid: "250176500003640",
//             totalAmount: 56,
//             raDeposit: 0,
//             depositDate: "",
//             balanceAmount: 4459,
//             locationName: "HADAPSAR",
//             organizationName: "Pune",
//         },
//         {
//             transactionDate: "24-04-2025",
//             vid: "250176500003636",
//             totalAmount: 23,
//             raDeposit: 0,
//             depositDate: "",
//             balanceAmount: 4875,
//             locationName: "HADAPSAR",
//             organizationName: "Pune",
//         },
//         {
//             transactionDate: "24-04-2025",
//             vid: "250176500003635",
//             totalAmount: 23,
//             raDeposit: 0,
//             depositDate: "",
//             balanceAmount: 4898,
//             locationName: "Anisha Lab Location",
//             organizationName: "Pune",
//         },
//         {
//             transactionDate: "24-04-2025",
//             vid: "250176500003634",
//             totalAmount: 33,
//             raDeposit: 0,
//             depositDate: "",
//             balanceAmount: 4921,
//             locationName: "PUNE MAIN LAB",
//             organizationName: "Pune",
//         },
//         {
//             transactionDate: "24-04-2025",
//             vid: "250176500003633",
//             totalAmount: 23,
//             raDeposit: 0,
//             depositDate: "",
//             balanceAmount: 4954,
//             locationName: "PUNE MAIN LAB",
//             organizationName: "Pune",
//         },
//         {
//             transactionDate: "24-04-2025",
//             vid: "250176500003632",
//             totalAmount: 23,
//             raDeposit: 0,
//             depositDate: "",
//             balanceAmount: 4977,
//             locationName: "PUNE MAIN LAB",
//             organizationName: "Pune",
//         },
//         {
//             transactionDate: "",
//             vid: "",
//             totalAmount: "",
//             raDeposit: 5000,
//             depositDate: "24-04-2025",
//             balanceAmount: 5000,
//             locationName: "",
//             organizationName: "",
//         },
//     ];

//     const transactions = data.filter(d => d.transactionDate || d.depositDate);
//     const raDeposits = data.filter(d => d.raDeposit > 0);
//     const totalDeposit = raDeposits.reduce((sum, d) => sum + d.raDeposit, 0);
//     const currentBalance = transactions[0]?.balanceAmount || 0;

//     return (
//         <CommonContainer heading="Patient Visit" buttonText="" onButtonClick={() => { }}>
//             <div className="container py-4">
//                 <h3 className="mb-4 text-dark border-bottom pb-2">🧾 Client Statement: <strong>LAB020408</strong></h3>

//                 {/* <ReactDatePicker
//                     selected={monthYear}
//                     onChange={setMonthYear}
//                     className="form-control"
//                     showMonthYearPicker
//                     dateFormat="MMMM yyyy"
//                     placeholderText="Select Start Date"
//                 /> */}

//                 {/* Summary Cards */}
//                 <div className="row mb-4 g-4">
//                     <div className="col-md-4">
//                         <div className="card shadow-sm border-0 bg-success text-white h-100">
//                             <div className="card-body">
//                                 <h6 className="text-uppercase">Total RA Deposit</h6>
//                                 <h4 className="mb-0">₹{totalDeposit}</h4>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="col-md-4">
//                         <div className="card shadow-sm border-0 bg-primary text-white h-100">
//                             <div className="card-body">
//                                 <h6 className="text-uppercase">Current Balance</h6>
//                                 <h4 className="mb-0">₹{currentBalance}</h4>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="col-md-4">
//                         <div className="card shadow-sm border-0 bg-info text-white h-100">
//                             <div className="card-body">
//                                 <h6 className="text-uppercase">Total Transactions</h6>
//                                 <h4 className="mb-0">{transactions.length}</h4>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Table */}
//                 <div className="table-responsive">
//                     <table className="table table-hover table-bordered align-middle shadow-sm">
//                         <thead className="table-light text-center">
//                             <tr>
//                                 <th>Date</th>
//                                 <th>Visit ID</th>
//                                 <th>Amount</th>
//                                 <th>Balance</th>
//                                 <th>Location</th>
//                                 <th>Organization</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {transactions.map((item, idx) => (
//                                 <tr key={idx} className={item.raDeposit > 0 ? "fw-bold table-info" : ""}>
//                                     <td className="text-nowrap text-center">{item.transactionDate || item.depositDate}</td>
//                                     <td className="text-nowrap text-center">{item.vid || "—"}</td>
//                                     <td className="text-nowrap text-center">
//                                         {item.raDeposit > 0
//                                             ? `+₹${item.raDeposit} (Deposit)`
//                                             : `₹${item.totalAmount}`
//                                         }
//                                     </td>
//                                     <td className="text-nowrap text-center">₹{item.balanceAmount}</td>
//                                     <td className="text-nowrap">{item.locationName || "—"}</td>
//                                     <td className="text-nowrap">{item.organizationName || "—"}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </CommonContainer>
//     );
// };

// export default TransactionComponent;
